import { fromJS, List, OrderedMap } from 'immutable';
import * as constants from './emails.constants';
import * as activityConstants from '../Activity/activity.constants';
import * as featuresConstants from '../features.constants';
import * as utils from './utils/emails.reducer.utils';

const campaignsFilter = OrderedMap([
  [`${[constants.FILTERS_CAMPAIGN_ARCHIVED]}`, false]
]);

const searchByActivityFilter = OrderedMap([
  [`${[activityConstants.FILTERS_ACTIVITY_SEARCH_BY_TEXT]}`, '']
]);


const emailsFilter = OrderedMap([
  [`${[activityConstants.FILTERS_ACTIVITY_ACTIVE]}`, true],
  [`${[activityConstants.FILTERS_ACTIVITY_STOPPED]}`, false],
]);

const initialState = fromJS({
  [constants.FILTERS]: {
    [constants.EMAILS]: emailsFilter,
    [constants.FILTERS_GROUP_NAME_CAMPAIGN]: campaignsFilter,
    [activityConstants.FILTER_BY_ACTIVITY]: searchByActivityFilter
  },
  [constants.SORT]: {
    [constants.ORDER]: constants.ORDER_DESCENDING
  },
  [constants.EMAILS]: [],
  [constants.EMAILS_LOADED]: false
});

function emailsReducer(state = initialState, action) {
  switch (action.type) {
    case constants.GET_EMAILS: {
      return state
        .set(constants.EMAILS_LOADED, false);
    }
    case constants.GET_EMAILS_CAMPAIGNS: {
      return state
        .set(constants.EMAILS_LOADED, false);
    }
    case constants.GET_EMAILS_SUCCESS: {
      return state
        .set(constants.EMAILS, fromJS(action.data))
        .set(constants.EMAILS_LOADED, true);
    }
    case constants.GET_EMAILS_CAMPAIGNS_SUCCESS: {
      return state
        .set(constants.EMAILS_CAMPAIGNS, fromJS(action.data))
        .set(constants.EMAILS_LOADED, true);
    }
    case constants.UPDATE_FILTERS: {
      const { status, key, groupKey } = action;
      return state.setIn([constants.FILTERS, groupKey, key], status);
    }
    case constants.UPDATE_ORDER: {
      return state
        .setIn([constants.SORT, constants.ORDER],
          state.getIn([constants.SORT, constants.ORDER]) === featuresConstants.ORDER_DESCENDING ?
            featuresConstants.ORDER_ASCENDING : featuresConstants.ORDER_DESCENDING
        );
    }

    case constants.HIGHLIGHT_ACTIVITY: {
      if (action[activityConstants.HIGHLIGHTED_ACTIVITY_ID]) {
        return state.set(activityConstants.HIGHLIGHTED_ACTIVITY_ID, action[activityConstants.HIGHLIGHTED_ACTIVITY_ID]);
      }
      return state.delete(activityConstants.HIGHLIGHTED_ACTIVITY_ID);
    }

    case constants.SEARCH_EMAILS: {
      return state.set(constants.SEARCH_TERM, action[constants.SEARCH_TERM]);
    }

    case constants.CLEAR_EMAIL_LIST: {
      return state.set(constants.EMAILS, List());
    }

    case constants.EMAIL_MOVE_TO_CAMPAIGN_SUCCESS: {
      const { data, oldCampaignId } = action;

      const oldCampaignIndex = utils.getEntityIndexById(
        state.get(constants.EMAILS_CAMPAIGNS),
        constants.CAMPAIGN_ID,
        oldCampaignId
      );

      const oldActivityIndex = utils.getEntityIndexById(
        state.getIn([constants.EMAILS_CAMPAIGNS, oldCampaignIndex, constants.EMAILS]),
        activityConstants.HUB_ID,
        data[activityConstants.HUB_ID]
      );

      // delete the email from the source (old) campaign
      let newState = state.deleteIn([constants.EMAILS_CAMPAIGNS, oldCampaignIndex, constants.EMAILS, oldActivityIndex]);

      // the index of the target campaign
      const campaignIndex = utils.getEntityIndexById(
        state.get(constants.EMAILS_CAMPAIGNS),
        constants.CAMPAIGN_ID,
        data.campaignKey
      );

      // push the email to the target campaign
      newState = newState.setIn([constants.EMAILS_CAMPAIGNS, campaignIndex, constants.EMAILS],
        newState.getIn([constants.EMAILS_CAMPAIGNS, campaignIndex, constants.EMAILS]).push(fromJS(data)));

      const { viewStatus } = data;

      // update campaign status according to activity status
      if (viewStatus === activityConstants.ACTIVITY_STATUS_ACTIVE) {
        newState = newState.setIn([constants.EMAILS_CAMPAIGNS, campaignIndex, constants.CAMPAIGN_STATUS], constants.CAMPAIGN_STATUS_ACTIVE);
      }

      return newState;
    }

    case constants.GET_EMAIL_STATS_SUCCESS: {
      const stats = action.data;
      return state
        .set(constants.EMAIL_STATS, fromJS(stats))
        .set(constants.EMAIL_STATS_LOADING, false);
    }

    case constants.UPDATE_EMAIL_STATUS_SUCCESS: {
      const email = action.data;
      return state.update(constants.EMAILS_CAMPAIGNS, (campaigns) =>
      campaigns.map((campaign) => {
        if (campaign.get(constants.CAMPAIGN_ID) !== email.campaignKey) return campaign;

        let updatedCampaign = campaign;

        // update campaign status according to email status
        if (email.status === activityConstants.ACTIVITY_STATUS_ACTIVE) {
          updatedCampaign = updatedCampaign.set(constants.CAMPAIGN_STATUS, constants.CAMPAIGN_STATUS_ACTIVE);
        }

        return updatedCampaign.update(constants.EMAILS, (emails) => {
          const emailIndex = emails.findIndex((e) => e.get(activityConstants.HUB_ID) === email[activityConstants.HUB_ID]);
          return emailIndex === -1 ? emails : emails.set(emailIndex, fromJS(email));
        });
      }));
    }

    case constants.CREATE_EMAILS_CAMPAIGN_SUCCESS: {
      return state
        .set(constants.EMAILS_CAMPAIGNS, state.get(constants.EMAILS_CAMPAIGNS).unshift(fromJS(action.data)))
        .set(constants.FOCUSED_CAMPAIGN_ID, action.data.campaignId)
        .set(constants.CAMPAIGNS_LOADED, true);
    }

    case constants.DEFOCUS_EMAILS_CAMPAIGN: {
      return state.set(constants.FOCUSED_CAMPAIGN_ID, null);
    }

    case constants.SET_EMAIL_STATS_LOADING: {
      return state.set(constants.EMAIL_STATS_LOADING, true);
    }
    case constants.CLEAN_EMAIL_STATS: {
      return state
        .delete(constants.EMAIL_STATS)
        .set(constants.EMAIL_STATS_LOADING, false);
    }

    case constants.GET_DETAILED_STATS_PER_ONETIME_CAMPAIGN_SUCCESS: {
      return state
        .setIn([constants.EMAIL_STATS_PER_CAMPAIGN, constants.EMAIL_CAMPAIGN_ID], action[constants.EMAIL_CAMPAIGN_ID])
        .setIn([constants.EMAIL_STATS_PER_CAMPAIGN, featuresConstants.DATA], fromJS(JSON.parse(action.data)));
    }

    case constants.GET_DETAILED_STATS_PER_RULE_SUCCESS: {
      let stats;
      if (action.data.length === 1) {
        stats = JSON.parse(action.data[0]);
      } else {
        stats = utils.combineStats(action.data);
      }
      return state
        .setIn([constants.EMAIL_STATS_PER_RULE, constants.RULE_ID], action.ruleId)
        .setIn([constants.EMAIL_STATS_PER_RULE, featuresConstants.DATA], fromJS(stats));
    }

    case constants.GET_DETAILED_STATS_PER_MICRO_CAMPAIGN_SUCCESS: {
      let stats;
      if (action.data.length === 1) {
        stats = JSON.parse(action.data[0]);
      } else {
        stats = utils.combineStats(action.data);
      }
      return state
        .setIn([constants.EMAIL_STATS_PER_MICRO_CAMPAIGN, constants.MICRO_CAMPAIGN_ID], action.microCampaignId)
        .setIn([constants.EMAIL_STATS_PER_MICRO_CAMPAIGN, featuresConstants.DATA], fromJS(stats));
    }

    case constants.CLEAN_DETAILED_EMAIL_STATS: {
      return state
        .delete(constants.EMAIL_STATS_PER_CAMPAIGN)
        .delete(constants.EMAIL_STATS_PER_RULE);
    }

    case constants.CLEAN_EMAIL_USAGES_DATA: {
      return state.delete(constants.EMAIL_USAGES);
    }

    case constants.GET_EMAIL_USAGES_SUCCESS: {
      const usages = action.data;
      return state.set(constants.EMAIL_USAGES, fromJS(usages));
    }

    case constants.UPDATE_EMAILS_CAMPAIGN_SUCCESS: {
      const { data } = action;
      return state.update(constants.EMAILS_CAMPAIGNS, (campaigns) =>
        campaigns.map((campaign) => (campaign.get(constants.CAMPAIGN_ID) === data.campaignId) ? fromJS(data) : campaign));
    }

    case constants.OPEN_TOAST: {
      const { message } = action;
      return state.set(constants.IS_TOAST_OPEN, true)
                  .set(constants.TOAST_MESSAGE, message);
    }

    case constants.CLOSE_TOAST: {
      return state.set(constants.IS_TOAST_OPEN, false)
        .set(constants.TOAST_MESSAGE, '');
    }

    default: {
      return state;
    }
  }
}

export default emailsReducer;
